import { Injectable, EventEmitter } from '@angular/core';
import {FontServiceBase} from 'storyboard-renderer';
import {NgbModalRef, NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class EditModal extends NgbModal {
  public modalOpened = new EventEmitter();

  open(content: any, options?: NgbModalOptions): NgbModalRef {
    this.modalOpened.emit();
    return super.open(content, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/shared/edit-modal.service.ts